import React, {useEffect, useMemo, useState} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import FormRenderer from '../../cmp/formbuilder/FormRenderer';
import {actionMergeSetting} from '../../../redux/settings/settingsAction';
import {getAccessToken, post} from '../../../api';
import Modal from '../../cmp/Modal';
import RenderTipaltiIframe from '../tipalti/RenderTipaltiIframe';
import {trimPostData} from '../../../tools/func';
import FormGroup from '../../cmp/form/FormGroup';
import useCaBanks from "../../../hooks/useCaBanks";
import {FiCheckCircle} from "react-icons/fi";
import Select from "../../cmp/form/Select";
import Button from '../../cmp/form/Button';
function validateBitcoinAddress(address) {
    // Regular expression to match Bitcoin addresses
    const btcAddressRegex = /^(1|3|bc1)[a-zA-Z0-9]{25,39}$/;
    return btcAddressRegex.test(address);
}
function validateUSBankAccount({
                                    bank_name,
                                   account_type,
                                   account_name,
                                   account_number,
                                   branch_code,
                               }) {
    const errors = {};
    if(!bank_name){
        errors.bank_name = 'Bank name is required';
    }
    if(!account_type){
        errors.account_type = 'Account type is required';
    }
    // Validate account name
    if (!account_name || account_name.trim() === '') {
        errors.account_name = 'Account name is required';
    }else {
        if (account_name.length < 2) {
            errors.account_name = 'Account name is too short';
        }
        if (account_name.length > 40) {
            errors.account_name = 'Account name is too long';
        }
        if (!/^[A-Za-z0-9 ]+$/.test(account_name.trim())) {
            errors.account_name = 'Account name can only contain letters, numbers, and spaces';
        }

    }


    // Validate account number (usually 4-17 digits)
    if (!account_number) {
        errors.account_number = 'Account number is required';
    } else if (!/^\d{4,17}$/.test(account_number)) {
        errors.account_number = 'Account number must be between 4-17 digits';
    }

    // Validate routing number (9 digits)
    if (!branch_code) {
        errors.branch_code = 'Routing number is required';
    } else if (!/^\d{9}$/.test(branch_code)) {
        errors.branch_code = 'Routing number must be exactly 9 digits';
    } else {
        // Check routing number using ABA checksum algorithm
        // Formula: 3(d1 + d4 + d7) + 7(d2 + d5 + d8) + (d3 + d6 + d9) % 10 should equal 0
        const digits = branch_code.split('').map(Number);
        const checksum =
            3 * (digits[0] + digits[3] + digits[6]) +
            7 * (digits[1] + digits[4] + digits[7]) +
            (digits[2] + digits[5] + digits[8]);

        if (checksum % 10 !== 0) {
            errors.branch_code = 'Routing number is invalid';
        }
    }

    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}

function PaymentInputPage({
      updateSettings,
      visible,
      onClose,
      onSubmit,
      available_payment_methods,
}){
    const [saving, setSaving] = useState(false)
    const [paymentDetails, setPaymentDetails] = useState({})
    const payment_details_data_string = useSelector((state)=>state.settings.payment_details_data);
    const payment_method = useSelector((state)=>state.settings.payment_method);
    useEffect(()=>{
        if(payment_details_data_string){
            const obj = typeof payment_details_data_string === "string" ? JSON.parse(payment_details_data_string) : payment_details_data_string;
            if(Object.keys(obj).length > 0){
                setPaymentDetails(obj)
            }
        }
        if(available_payment_methods && available_payment_methods.length === 1){
            setPaymentMethod(available_payment_methods[0].key)
        }else if(payment_method){
            setPaymentMethod(payment_method)
        }
    },[available_payment_methods, payment_details_data_string, payment_method])
    const [paymentMethod, setPaymentMethod] = useState(payment_method || '')
    const [errors, setErrors] = useState({})
    const save = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setErrors(null)
        if(paymentMethod === "bank" && country === "US"){
            setErrors(null)
            const {
                isValid,
                errors
            } = validateUSBankAccount(paymentDetails);
            if(!isValid){
                setErrors(Object.values(errors))
                return;
            }
        }
        if(paymentMethod === "paypal"){
            const email = paymentDetails['paypal_email'];
            if(!email || email.length < 5 || email.indexOf('@') === -1) {
                setErrors(['Email is invalid'])
                return;
            }
        }
        if(paymentMethod === "venmo"){
            const phone = paymentDetails['venmo_id'];
            if(!phone || phone.length < 10) {
                alert('error')
                setErrors(['Phone number is invalid'])
                return;
            }
        }
        if(paymentMethod === "bitcoin"){
            const btc = paymentDetails['btc'];
            if(!btc || btc.length < 10 || !validateBitcoinAddress(btc)) {
                setErrors(['Bitcoin address is invalid'])
                return;
            }
        }
        if(onSubmit){
            if(paymentMethod) {
                onSubmit({
                    payment_method: paymentMethod,
                    payment_details_data: trimPostData(paymentDetails)
                })
            }
            onClose();
            return;
        }
        setSaving(true)
        post('/', {
            payment_method: paymentMethod,
            payment_details_data: JSON.stringify(trimPostData(paymentDetails))
        }).then((data) => {
            updateSettings(data);
            setSaving(false)
            onClose();
        }).catch((e) => {
            setSaving(false)
        });
    }

    const shouldEnable = (form)=>{
        const values = paymentDetails;
        for (let x = 0; x < form.length; x++) {
            const {id, isRequired, isEnabled} = form[x];
            if (isEnabled && isRequired){
                if(typeof values[id] === "string"){
                    if(!values[id].trim()){
                        return false;
                    }
                }else if(typeof values[id] === "boolean"){
                    return true;
                }
                else if(!values[id] || values[id].length === 0) {
                    return false;
                }
            }
        }
        return true;
    }
    const onChange = (data)=> {
        setPaymentDetails((d)=>{return {...d, ...data}})
    }
    const data  = useCaBanks();
    const currency = useSelector((state)=>state.settings.default_currency)
    const country = useSelector((state)=>state.settings.country)
    const isInUSA = country === "US" || country === "CA"
    const form = useMemo(()=>{
        const found =  available_payment_methods.find((item)=>item.key===paymentMethod)
        let vals =  found && found.form ? found.form : [];
        if (paymentMethod === "bank") {
            //TODO determine if we want to update the inputs or not
            if (country === "CA") {
                vals = vals
                    .filter(({ id }) => id !== "swift_name")
                    .map((i) => {
                        if (i.id === "bank_name") {
                            return {
                                ...i,
                                type: "select",
                                options: data
                                    ? data?.map((item) => {
                                        return {
                                            label: `${item.number} - ${item.name}`,
                                            value: item.number,
                                        };
                                    })
                                    : [],
                            };
                        }
                        if(i.id === "account_number"){
                            return {
                                ...i,
                                // type:'number',
                                // max:12,
                                label: "Account Number (8 to 12 digits)",
                            }
                        }
                        if(i.id === "branch_code"){
                            return {
                                ...i,
                                // type:'number',
                                // max:5,
                                label: "Routing Number (5 digits)",
                            }
                        }
                        return i;
                    });
            }
            if (currency === "INR") {
                return vals
                    .filter(({ id }) => id !== "swift_name")
                    .map((i) => {
                        return i.id === "branch_code"
                            ? {
                                ...i,
                                label: "IFSC Code",
                            }
                            : i;
                    });
            }
        }
        if(paymentMethod === "bank" && isInUSA){
            // do not display is the user is in USA
            return vals.filter(({id})=>id !== "swift_name")
        }else{
            return vals;
        }
    },[available_payment_methods,currency,data, country, paymentMethod, isInUSA])

    return (
            <Modal
                size={paymentMethod === "tipalti" ? 'lg' : null}
                onCancel={onClose}
                visible={visible}
                disabled={!shouldEnable(form)}
                onSubmit={save} confirmLoading={saving}
                okText={<FormattedMessage id={"Submit"} />}>
                <FormGroup label={'Payment Mode'} required>
                    <select className={'form-control'} value={paymentMethod}
                            onChange={(e)=>setPaymentMethod(e.target.value)}>
                        <Opt value={''} id={'No payment mode set'}/>
                        {
                            available_payment_methods.map((item)=>{
                                return <Opt key={item.key} id={item.title} value={item.key} />
                            })
                        }
                    </select>
                </FormGroup>
                {
                    paymentMethod === "tipalti" ? <RenderTipaltiIframe type={"payment_details"} /> : null
                }
                {
                    paymentMethod === "hyperwallet" ? <RenderHyperwallet  /> : null
                }
                <FormRenderer formFields={form}
                              onChange={onChange}
                              value={paymentDetails} />
                {
                    errors && errors.length === 1 ? <div className={'text-danger'}>
                        {errors[0]}
                    </div> : null
                }
                {
                    errors && errors.length > 1 ? <div className={'text-danger'}>
                        <ol>
                            {errors.map((item, index)=><li key={index}>{item}</li>)}
                        </ol>
                    </div> : null
                }
            </Modal>
        );
}

const usStatesList = [
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "American Samoa", value: "AS" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "Washington, D.C.", value: "DC" },
    { label: "Federated States of Micronesia", value: "FM" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Guam", value: "GU" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Marshall Islands", value: "MH" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Northern Mariana Islands", value: "MP" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Palau", value: "PW" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Puerto Rico", value: "PR" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "United States Virgin Islands", value: "VI" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" },
    { label: "Armed Forces America", value: "AA" },
    { label: "Armed Forces Pacific", value: "AP" },
    { label: "Armed Forces Europe", value: "AE" }
];


function RenderHyperwallet(){
    const payment_details_data = useSelector((state)=>state.settings.payment_details_data);
    const parsed = useMemo(()=>{
        return typeof payment_details_data === "string" ? JSON.parse(payment_details_data) : payment_details_data;
    }, [payment_details_data])
    const country = useSelector((state)=>state.settings.country);
    const state = useSelector((state)=>state.settings.state);
    const needToAskState = country === "US" && String(state).length !== 2;
    const site_id = useSelector((state)=>state.settings.site_id);
    const [userState, setUserState] = useState(needToAskState ? '' : state);
    const [creating, setCreating] = useState(false)
    const [errors, setError] = useState(null);
    const dispatch = useDispatch();
    const [newlyCreated, setNewlyCreated] = useState(false);
    const submit = async ()=>{
        setCreating(true)
        const access_token = getAccessToken();
        const result = await fetch('https://custom-api.goaffpro.com/hyperwallet/upsert-account', {
            method:'POST',
            headers:{
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                access_token: access_token,
                site_id,
                state: userState,
            })
        }).then((res)=>res.json());
        if(result.usrToken){
            setNewlyCreated(true)
            dispatch(actionMergeSetting({
                payment_method:'hyperwallet',
                payment_details_data: JSON.stringify(result),
            }))
        }else if(result.error){
            setError(result.error)
        }
        setCreating(false)
    }
    return <div>
        <div className={"text-center mb-2 py-4 rounded"} style={{backgroundColor:'rgb(40,96,154)'}}>
            <img alt={"Hyperwallet logo"} src={"/assets/hyperwallet-logo-white.svg"} style={{maxWidth:'80%'}} />
        </div>
        {
            errors ? <div className={'text-danger text-center mb-2'}>{errors}</div> : null
        }
        {
            parsed?.usrToken ? <div className={"mt-4"}>
                <p className="text-center">
                    <FiCheckCircle className={"text-success"} size={48} />
                </p>
                {
                    newlyCreated ?
                <p className={"text-center"}>Your HyperWallet account has been created successfully. You can now use it to receive payments. You may close this popup now</p> :
                        null
                }
            </div> : <div>
                {
                    needToAskState ? <FormGroup label={"Choose your state"} required>
                            <Select hasEmpty options={usStatesList} value={userState} onChange={setUserState}/>
                    </FormGroup> : null
                }
                <div className="text-center">
                    <Button className={"btn btn-primary"}
                            onClick={submit}
                            type={"button"} loading={creating} disabled={needToAskState && !userState}>Click here to create your HyperWallet account</Button>

                </div>
            </div>
        }
    </div>
}

function mapStateToProps(state, props) {
    const {available_payment_methods} = state.settings;
     const payment_method = props.payment_method ?? state.settings.payment_method
     const payment_details_data = props.payment_details_data ?? state.settings.payment_details_data ?? {};
    return {
        available_payment_methods,
        payment_method,
        payment_details_data: typeof payment_details_data === "string" ? JSON.parse(payment_details_data) : payment_details_data,
    };
}

function Opt({id, value}) {
    return <FormattedMessage id={id || " "}>{text => <option id={createId(id)} value={value}>{text}</option>}</FormattedMessage>
}

function mapDispatchToProps(dispatch, props) {
    return {
        updateSettings: (change) => dispatch(actionMergeSetting(change))
    };
}

function createId(id){
    return id ? String(id).replace(/[^a-z0-9]/gi, '') : ''
}



export default connect(
    mapStateToProps, mapDispatchToProps
)(PaymentInputPage);
